
namespace TabAurous.Master {

    @Serenity.Decorators.registerClass()
    export class CustomerCategoryGrid extends Serenity.EntityGrid<CustomerCategoryRow, any> {
        protected getColumnsKey() { return 'Master.CustomerCategory'; }
        protected getDialogType() { return CustomerCategoryDialog; }
        protected getIdProperty() { return CustomerCategoryRow.idProperty; }
        protected getInsertPermission() { return CustomerCategoryRow.insertPermission; }
        protected getLocalTextPrefix() { return CustomerCategoryRow.localTextPrefix; }
        protected getService() { return CustomerCategoryService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}